export default {
    intro_header: "Jakie piwo dobrać&nbsp;do potraw?",
    intro_content_1: "Twoi goście mają ochotę na pyszny obiad w towarzystwie Książęcego?",
    intro_content_2: "Skorzystaj z generatora foodpairingowego i sprawdź, które piwo najlepiej pasuje do wybranego dania! Skomponuj wyjątkowe menu i serwuj połączenia, które zachwycą wszystkich!",

    no_results: "Brak wyników wyszkiwania.",
    no_results_content: "Wyślij nam propozycję potrawy, chętnie dodamy ją do naszej bazy",
    no_results_cta: "Zaproponuj potrawę",

    search: "Wyszukaj danie",

    alcohol: "Alkohol",
    alcohol_suffix: "obj.",
    bitterness: "Goryczka",
    bitterness_suffix: "IBU",

    and: "oraz",
    change: "Zmień",

    beer_dish: "Do twojego dania pasuje",
    beer_match: "Dopasuj piwo do kolejnego dania",

    popup_optional: "Możesz dodać opcjonalnie:",
    popup_no_additive: "Dodatek (brak)",
    popup_not_found: "Nie znaleziono",
    popup_sauce: "sos",
    popup_sauce_none: "Sos (brak)",
    popup_cta: "Dopasuj piwo",

    form_required: "Pole obowiązkowe",
    form_wrong_email: "Niepoprawny adres e-mail",
    form_title: "Zaproponuj potrawę",
    form_name: "Wpisz nazwę potrawy",
    form_description: "Opis potrawy (opcjonalnie)",
    form_email: "Adres E-mail",
    form_restaurant: "Nazwa lokalu (opcjonalnie)",
    form_submit: "Wyślij",
    form_success: "Dziękujemy za&nbsp;propozycję",
    form_add_more: "Dodaj kolejne",

    select_category: "Wybierz kategorię"
}